import { Box } from "@mui/material";

export const Divider: React.FC = (props) => {
  return (
    <Box
      sx={{
        borderBottom: "2px solid #E0E0E0",
      }}
    />
  );
};
